export const SITE_NAME = 'leadership.NET'
export const SITE_ORIGIN = 'https://leadership.net'

export const PUBLIC_ROUTE_METADATA = {
  '/': {
    title: 'leadership.NET | Leadership Decision Interpretation Architecture',
    description:
      'leadership.NET defines the structure through which leadership intent is interpreted and becomes action in complex organizations.',
    canonical: `${SITE_ORIGIN}/`
  },
  '/implementation': {
    title: 'Implementation Support | leadership.NET',
    description:
      'Learn how leadership.NET implementation support protects the correct application of its standards without replacing leadership accountability.',
    canonical: `${SITE_ORIGIN}/implementation`
  }
}

export const NOT_FOUND_METADATA = {
  title: 'Page not found | leadership.NET',
  description: 'The requested leadership.NET page could not be found.'
}

export const PRIVATE_ROUTE_PREFIXES = [
  '/login',
  '/auth/',
  '/account/',
  '/dashboard/',
  '/admin/',
  '/payment/',
  '/checkout/',
  '/preview/',
  '/token/'
]

export const normalizePathname = (pathname) => {
  if (pathname === '/') return '/'

  const withoutTrailingSlash = pathname.replace(/\/+$/, '')
  return withoutTrailingSlash || '/'
}

export const getRouteMetadata = (pathname) => {
  const normalizedPathname = normalizePathname(pathname)
  const publicMetadata = Object.entries(PUBLIC_ROUTE_METADATA).find(
    ([route]) => route === normalizedPathname
  )?.[1]

  if (publicMetadata) return { ...publicMetadata, robots: 'index, follow' }

  return {
    ...NOT_FOUND_METADATA,
    robots: 'noindex, nofollow'
  }
}

export const getStructuredData = (pathname) => {
  const normalizedPathname = normalizePathname(pathname)

  if (normalizedPathname === '/') {
    return {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${SITE_ORIGIN}/#organization`,
          name: SITE_NAME,
          url: `${SITE_ORIGIN}/`
        },
        {
          '@type': 'WebSite',
          '@id': `${SITE_ORIGIN}/#website`,
          name: SITE_NAME,
          url: `${SITE_ORIGIN}/`,
          publisher: { '@id': `${SITE_ORIGIN}/#organization` }
        }
      ]
    }
  }

  if (normalizedPathname === '/implementation') {
    const metadata = PUBLIC_ROUTE_METADATA['/implementation']

    return {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${metadata.canonical}#webpage`,
      url: metadata.canonical,
      name: metadata.title,
      description: metadata.description,
      isPartOf: { '@id': `${SITE_ORIGIN}/#website` }
    }
  }

  return null
}
